import _ from 'lodash'
import appWidgetDefinition from './appWidgetDefinition.json'
import responsiveOverrides from './responsiveOverrides.json'

export const responsiveAppWidgetStructure = _.assign({}, appWidgetDefinition, responsiveOverrides)
